import * as types from '../mutation-types'

// state
export const state = {
    tabs: {},
};

// mutations
export const mutations = {
    [types.SET_TAB_STATE](state, { name, value }) {
        state.tabs[name] = value;
    }
};

// actions
export const actions = {
    setTabState({commit, dispatch}, payload) {
        commit(types.SET_TAB_STATE, payload)
    },
};

// getters
export const getters = {
    tabState(state) {
        return name => name in state.tabs ? state.tabs[name] : state.tabs[name] = 0
    }
};